export const PUSH_NOTIFICATION_TITLES = {
  SHIFT_SCHEDULAR: {
    REVIEW_SHIFT: 'Review Schedule',
    PUBLISH_SHIFTS: 'Schedule Published',
    RELEASE_SHIFT: 'Shift pool',
    SWAP_REQUEST: 'Swap Request',
    SWAP_CANCELLED: 'Swap Cancelled',
    SWAP_RESUBMIT: 'Swap Request Resubmitted',
    OPEN_SHIFT: 'Open Shift',
    REVIEW_BID: 'Review Bids',
  },
  TASK_MANAGER: {
    TASK_ASSIGNED: 'Task assigned',
    TASK_STARTED: 'Task started',
    TASK_COMPLETED: 'Task completed',
    TASK_REASSIGNED: 'Task re-assigned',
  },
  AVAILABILITY: {
    AVAILABILITY: 'Availability',
  },
  TIME_OFF: {
    REVIEW_TIME_OFF: 'Time off request',
    UPDATED_TIME_OFF: 'Time off request updated',
    APPROVED_TIME_OFF: 'Time off request approved',
    DECLINED_TIME_OFF: 'Time off request declined',
  },
  CAMPAIGN: {
    REVIEW_CAMPAIGN: 'Campaign',
  },
  DOC_VAULT: {
    DOCUMENT_EXPIRING: 'Document Expiring',
  },
  CHAT: {
    NEW_MESSAGE: 'Chat',
  },
  CLOCK_OUT: {
    AUTO_CLOCK_OUT: 'Auto Clock Out',
  },
  PREP_LIST_RECIPE: {
    PREP_RECIPE: 'Prep recipe',
  },
};
